export default __webpack_public_path__ + "static/media/13.bb231cb2.pdf";